import { useContext, useRef } from "react";
import MyContext from "../context/MyContext";

// One place to add an undo step (Ctrl+Z) before changing layers.
// Repeated changes of the same kind within 0.8 s (dragging a slider, typing a number) make ONE
// undo step, so Ctrl+Z goes back to before the slider was touched instead of one notch.

let last = { key: null, at: 0 };

export function pushUndo(ctx, layers, groupKey) {
  if (!ctx || !ctx.setUndoLayer) return;
  const now = Date.now();
  if (groupKey && last.key === groupKey && now - last.at < 800) {
    last.at = now;
    return;
  }
  last = { key: groupKey || null, at: now };
  const stack = [...(ctx.UndoLayer || [])];
  stack.push([...(layers || [])]);
  if (stack.length > 10) stack.shift();
  ctx.setUndoLayer(stack);
  if (ctx.setRedoLayer) ctx.setRedoLayer([]);
}

/** In a component: const undo = useUndo(); ... undo("opacity"); before changing layers. */
export function useUndo() {
  const ctx = useContext(MyContext);
  const ref = useRef(ctx);
  ref.current = ctx;
  return (groupKey) => pushUndo(ref.current, ref.current && ref.current.LayersData, groupKey);
}
